import { gql } from "@apollo/client";

export const GET_TENANTS = gql`
query getTenents($pageOptions: PageOptions) {
    getTenents(pageOptions: $pageOptions) {
        arcimedes_row_id
        name
        deleted
        arcimedes_created
        arcimedes_created_by
        arcimedes_modified
        arcimedes_modified_by
    }
}
`

export const GET_TENANTS_WITH_FILTERS = gql`
query getTenents($pageOptions: PageOptions,$filters: [Filters], $sortOptions: [SortOptions]) {
    getTenents(pageOptions: $pageOptions, filters: $filters, sortOptions: $sortOptions) {
        tenents{
            arcimedes_row_id
            name
            deleted
            arcimedes_created
            arcimedes_created_by
            arcimedes_modified
            arcimedes_modified_by
        }
        totalCount
    }
}
`

export const GET_TENANT_BY_ID = gql`
query getTenentById($arcimedes_row_id: ID!){
    getTenent(arcimedes_row_id: $arcimedes_row_id){
        arcimedes_row_id
        name
        deleted
        arcimedes_created
        arcimedes_created_by
        arcimedes_modified
        arcimedes_modified_by
    }
}
`